export const convertIndex = (count: number, index: number, total: number) =>
  Math.floor((count / total) * index);
